<template>
  <div class="page-container">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="nav-content">
        <div class="company-logo">
          <h1 style="font-size: 1.2rem">广州添添健康信息咨询有限公司</h1>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-item active">首页</router-link>
          <router-link to="/about" class="nav-item">关于我们</router-link>
          <router-link to="/business" class="nav-item">业务板块</router-link>
        </nav>
      </div>
    </header>

    <!-- 主横幅 -->
    <section class="hero">
      <div class="hero-content">
        <h2 class="hero-title">智慧养老新生态的开创者</h2>
        <p class="hero-subtitle">致力于打造中国口碑第一的银发用户生活服务电商平台</p>
        <p class="hero-description">帮助1亿中国银发用户享受更健康美好的生活</p>
        <div class="hero-actions">
<!--          <a href="#market" class="primary-btn">了解市场机遇</a>-->
<!--          <a href="#business" class="outline-btn">查看业务布局</a>-->
        </div>
      </div>
<!--      <div class="hero-media">-->
<!--        <img src="/images/hero-banner.jpg" alt="智慧养老新生态" class="hero-image">-->
<!--        <div class="hero-decoration">-->
<!--          <div class="decoration-item item1"></div>-->
<!--          <div class="decoration-item item2"></div>-->
<!--          <div class="decoration-item item3"></div>-->
<!--        </div>-->
<!--      </div>-->
    </section>

    <!-- 市场机遇 -->
    <section id="market" class="market-section">
      <div class="content-wrapper">
        <h2 class="section-title">巨大的市场机遇</h2>
        <div style="padding-left: 150px">
          <div class="market-overview">
            <p class="market-intro">
              大健康产业迎来黄金发展期，国家政策全面支持银发经济发展
            </p>
            <div class="market-quote">
              <blockquote>
                "大健康时代是继机械化时代、电气化时代、计算机时代与信息网络时代之后的全球财富第五波"
              </blockquote>
              <cite style="margin-left: 60%">— 著名经济学家 保罗·皮尔泽《财富第五波》</cite>
            </div>
          </div>

          <div class="data-grid">
            <div class="data-card primary" v-for="(stat, index) in marketStats" :key="index">
              <div class="number-wrapper">
                <span class="number" :data-value="stat.value">{{ stat.value }}</span>
                <span class="unit">{{ stat.unit }}</span>
              </div>
              <p class="data-label" style="font-weight: bold">{{ stat.label }}</p>
              <p class="data-desc">{{ stat.desc }}</p>
            </div>
          </div>

          <div class="policy-support">
            <h3 class="support-title">国家政策支持</h3>
            <div class="policy-grid">
              <div class="policy-card">
                <div class="policy-icon">📋</div>
                <div class="policy-content">
                  <h4>首个银发经济政策文件</h4>
                  <p>2024年1月，国务院印发《关于发展银发经济增进老年人福祉的意见》</p>
                </div>
              </div>
              <div class="policy-card">
                <div class="policy-icon">🎯</div>
                <div class="policy-content">
                  <h4>明确发展目标</h4>
                  <p>到2027年，银发经济市场规模突破10万亿元，基本形成高质量发展体系</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 业务板块 -->
    <section id="business" class="business-section">
      <div class="content-wrapper">
        <h2 class="section-title">四大核心业务板块</h2>
        <p class="business-intro">以"一个平台+四大板块"战略布局，打造全方位的银发生活服务生态系统</p>

        <div class="business-grid">
          <div class="business-card">
            <div class="card-header">
              <div class="card-icon">🎯</div>
              <h3>兴趣探索</h3>
            </div>
            <div class="card-content">
              <div class="service-list">
                <div class="service-item">
                  <h4>健康养身</h4>
                  <p>太极、瑜伽、养生操等适老化运动课程</p>
                </div>
                <div class="service-item">
                  <h4>技能培训</h4>
                  <p>手机使用、摄影、书法等兴趣技能课程</p>
                </div>
                <div class="service-item">
                  <h4>文化康养</h4>
                  <p>戏曲、读书会、棋牌等文化娱乐活动</p>
                </div>
                <div class="service-item">
                  <h4>游学旅居</h4>
                  <p>主题疗养、文化游学、候鸟式旅居服务</p>
                </div>
              </div>
            </div>
          </div>

          <div class="business-card">
            <div class="card-header">
              <div class="card-icon">💊</div>
              <h3>保健养生</h3>
            </div>
            <div class="card-content">
              <div class="service-list">
                <div class="service-item">
                  <h4>营养保健</h4>
                  <p>营养补充剂、保健食品、养生茶饮</p>
                </div>
                <div class="service-item">
                  <h4>医疗器械</h4>
                  <p>健康监测、康复辅具、家用医疗设备</p>
                </div>
                <div class="service-item">
                  <h4>药食同源</h4>
                  <p>养生食材、滋补品、营养餐配送</p>
                </div>
                <div class="service-item">
                  <h4>健康管理</h4>
                  <p>健康档案、营养方案、运动指导</p>
                </div>
              </div>
            </div>
          </div>

          <div class="business-card">
            <div class="card-header">
              <div class="card-icon">🏥</div>
              <h3>医疗养老</h3>
            </div>
            <div class="card-content">
              <div class="service-list">
                <div class="service-item">
                  <h4>医疗服务</h4>
                  <p>在线问诊、预约挂号、体检服务</p>
                </div>
                <div class="service-item">
                  <h4>养老照护</h4>
                  <p>居家照护、养老社区、康复护理</p>
                </div>
                <div class="service-item">
                  <h4>保险理财</h4>
                  <p>养老保险、健康险、养老理财</p>
                </div>
                <div class="service-item">
                  <h4>健康咨询</h4>
                  <p>专家咨询、心理辅导、用药指导</p>
                </div>
              </div>
            </div>
          </div>

          <div class="business-card">
            <div class="card-header">
              <div class="card-icon">🛍️</div>
              <h3>日常生活</h3>
            </div>
            <div class="card-content">
              <div class="service-list">
                <div class="service-item">
                  <h4>服饰穿搭</h4>
                  <p>适老化服装、保暖服饰、养生鞋品</p>
                </div>
                <div class="service-item">
                  <h4>食品饮料</h4>
                  <p>健康食品、有机食材、营养饮品</p>
                </div>
                <div class="service-item">
                  <h4>生活用品</h4>
                  <p>智能家居、适老化用品、养生寝具</p>
                </div>
                <div class="service-item">
                  <h4>个人护理</h4>
                  <p>护肤美容、口腔护理、生活护理</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心优势 -->
    <section class="advantage-section">
      <div class="content-wrapper">
        <h2 class="section-title">我们的核心优势</h2>
        <div class="advantage-grid">
          <div class="advantage-card">
            <div class="advantage-icon">👥</div>
            <h3>专业团队</h3>
            <ul class="advantage-list">
              <li>核心团队拥有20年快消品及电商运营经验</li>
              <li>汇聚医疗、养老、电商等多领域专家</li>
              <li>深耕银发市场，深度理解用户需求</li>
            </ul>
          </div>

          <div class="advantage-card">
            <div class="advantage-icon">🤝</div>
            <h3>资源整合</h3>
            <ul class="advantage-list">
              <li>整合全国优质医疗及养老资源</li>
              <li>与头部媒体建立深度战略合作</li>
              <li>打造多元化的渠道分销网络</li>
            </ul>
          </div>

          <div class="advantage-card">
            <div class="advantage-icon">💡</div>
            <h3>创新模式</h3>
            <ul class="advantage-list">
              <li>首创"互联网+养老"新零售模式</li>
              <li>建立智能化会员服务体系</li>
              <li>打造线上线下深度融合的服务网络</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业荣誉 -->
    <section class="honor-section">
      <div class="content-wrapper">
        <h2 class="section-title">企业荣誉</h2>
        <div class="honor-grid">
          <div class="honor-card">
            <div class="honor-icon">🏆</div>
            <h3>重点项目</h3>
            <p>广州市重点招商引资项目企业</p>
          </div>
          <div class="honor-card">
            <div class="honor-icon">🌟</div>
            <h3>行业标杆</h3>
            <p>中国养老产业创新示范企业</p>
          </div>
          <div class="honor-card">
            <div class="honor-icon">📈</div>
            <h3>高速成长</h3>
            <p>大健康产业成长最快企业TOP10</p>
          </div>
        </div>
      </div>
    </section>

    <footer class="footer">
      <div class="content-wrapper">
<!--        <div class="footer-grid">-->
<!--          <div class="footer-info">-->
<!--            <h3>广东添添健康产业集团有限公司</h3>-->
<!--            <p>致力于打造中国领先的银发经济产业平台</p>-->
<!--          </div>-->
<!--          <div class="footer-contact">-->
<!--            <h4>联系我们</h4>-->
<!--            <p>电话：020-XXXXXXXX</p>-->
<!--            <p>邮箱：contact@example.com</p>-->
<!--            <p>地址：广州市XXX区XXX路XX号</p>-->
<!--          </div>-->
<!--        </div>-->
        <div class="footer-bottom">
          <p>© 2024 广州添添健康信息咨询有限公司 版权所有 备案号 <a href="https://beian.miit.gov.cn" target="_blank" style="color: rgba(255, 255, 255, 0.5)">粤ICP备2024303205号</a> </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      marketStats: [
        {
          value: 14,
          unit: '万亿+',
          label: '大健康产业市场规模',
          desc: '2023年中国大健康产业市场规模突破14万亿，预计2025年将达到20万亿'
        },
        {
          value: 7,
          unit: '万亿+',
          label: '银发经济市场规模',
          desc: '2023年中国银发经济市场规模超7万亿，年均复合增长率达15%'
        },
        {
          value: 332,
          unit: '百万',
          label: '50+网民数量',
          desc: '中国50岁以上网民规模达3.32亿，互联网渗透率持续提升'
        }
      ]
    }
  },
  mounted() {
    // 数字增长动画
    this.initAnimations();
    // 监听滚动以触发动画
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    initAnimations() {
      this.animateNumbers();
      this.initScrollAnimations();
    },
    animateNumbers() {
      const numbers = document.querySelectorAll('.number');
      numbers.forEach(num => {
        const value = parseInt(num.getAttribute('data-value'));
        this.animateValue(num, 0, value, 2000);
      });
    },
    animateValue(obj, start, end, duration) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    },
    initScrollAnimations() {
      // 初始化滚动动画，跳过首屏内容
      const sections = document.querySelectorAll('section:not(.hero)');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        // 只对首屏以下的内容添加动画类
        if (sectionTop > windowHeight) {
          section.classList.add('scroll-animation');
        }
      });
    },
    handleScroll() {
      // 处理滚动动画
      const sections = document.querySelectorAll('.scroll-animation');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (sectionTop < windowHeight * 0.75) {
          section.classList.add('animate');
        }
      });
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #4169E1;
  --primary-light: #6B8FF2;
  --primary-dark: #2850B8;
  --secondary-color: #34c759;
  --secondary-light: #5FE17F;
  --secondary-dark: #28A347;
  --accent-color: #ff9500;
  --accent-light: #FFB44C;
  --accent-dark: #CC7700;
  --success-color: #00C48C;
  --warning-color: #FFB800;
  --danger-color: #FF3B30;
  --info-color: #0A84FF;
  --light-bg: #f8f9ff;
  --card-bg: #ffffff;
  --dark-accent: #2c3e50;
  --text-primary: #2C3E50;
  --text-secondary: #526488;
  --text-light: #8492A6;
  --gradient-primary: linear-gradient(135deg, var(--primary-color), #7e57c2);
  --gradient-secondary: linear-gradient(135deg, var(--secondary-color), #4cd964);
  --gradient-accent: linear-gradient(135deg, var(--accent-color), #ff3b30);
  --shadow-sm: 0 2px 8px rgba(65, 105, 225, 0.1);
  --shadow-md: 0 4px 16px rgba(65, 105, 225, 0.15);
  --shadow-lg: 0 8px 24px rgba(65, 105, 225, 0.2);
}

/* 整体布局容器 */
.page-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

/* 内容包装器 */
.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

/* 横幅样式 */
.hero {
  position: relative;
  padding: 400px 0 300px;
  background: linear-gradient(135deg, var(--primary-color), #7e57c2);
  color: white;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
  background-size: cover;
  background-position: center;
  //opacity: 0.15;
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-title {
  font-size: 6rem;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 20px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  //color: black;
  animation: fadeInUp 1s ease-out;
}

.hero-subtitle {
  font-size: 3rem;
  margin-bottom: 15px;
  font-weight: 500;
  line-height: 1.4;
  //color: black;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.hero-description {
  font-size: 2rem;
  margin-bottom: 30px;
  line-height: 1.6;
  font-weight: 300;
  //color: black;
  opacity: 0.9;
  animation: fadeInUp 1s ease-out 0.4s both;
}

.hero-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 40px;
  animation: fadeInUp 1s ease-out 0.6s both;
}

.primary-btn,
.outline-btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.primary-btn {
  background-color: white;
  color: var(--primary-color);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.outline-btn {
  border: 2px solid white;
  color: white;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.outline-btn:hover {
  background-color: white;
  color: var(--primary-color);
}

.hero-media {
  position: relative;
  margin-top: 60px;
  z-index: 2;
}

.hero-image {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: block;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.hero-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.decoration-item {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.item1 {
  width: 200px;
  height: 200px;
  top: -100px;
  left: 10%;
  animation: float 8s ease-in-out infinite;
}

.item2 {
  width: 150px;
  height: 150px;
  bottom: -50px;
  right: 15%;
  animation: float 12s ease-in-out infinite 1s;
}

.item3 {
  width: 100px;
  height: 100px;
  top: 30%;
  right: 5%;
  animation: float 6s ease-in-out infinite 0.5s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .hero {
    padding: 100px 0 60px;
  }

  .hero-title {
    font-size: 2.2rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
  }

  .hero-description {
    font-size: 1.1rem;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .primary-btn,
  .outline-btn {
    width: 100%;
    max-width: 300px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.8rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .hero-description {
    font-size: 1rem;
  }
}

/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  backdrop-filter: blur(5px);
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.company-logo h1 {
  font-size: 1.5rem;
  color: var(--primary-color);
  margin: 0;
  font-weight: 600;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-item {
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 500;
  padding: 5px 0;
  position: relative;
  transition: color 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
  color: var(--primary-color);
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
  width: 100%;
}

/* 通用容器和标题样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 5;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 40px;
  color: var(--primary-color);
  position: relative;
  padding-bottom: 15px;
  font-weight: 600;
}

.section-title::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, var(--primary-color), var(--secondary-color));
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

/* 市场数据部分样式 */
.market-section {
  padding: 80px 0;
  background:
    radial-gradient(circle at center, rgba(65, 105, 225, 0.1) 0%, transparent 70%),
    linear-gradient(45deg, rgba(147, 112, 219, 0.08) 0%, transparent 60%);
  position: relative;
}

.market-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 40px;
  position: relative;
  z-index: 2;
}

.stat-item {
  text-align: center;
  width: 28%;
  transition: all 0.3s ease;
  position: relative;
}

.stat-item:hover {
  transform: translateY(-5px);
}

.stat-circle {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: var(--card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  position: relative;
  z-index: 2;
  color: var(--primary-color);
}

.stat-item p {
  color: var(--text-secondary);
  font-size: 1rem;
  margin-top: 10px;
  position: relative;
}

.market-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  background-color: var(--card-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 2;
  border-top: 4px solid var(--primary-color);
}

.market-content p {
  margin-bottom: 15px;
  line-height: 1.6;
  color: var(--text-secondary);
  position: relative;
}

/* 业务板块样式 */
.business-section {
  padding: 80px 0;
  background:
    radial-gradient(circle at center, rgba(50, 205, 50, 0.08) 0%, transparent 70%),
    linear-gradient(-45deg, rgba(0, 255, 127, 0.06) 0%, transparent 60%);
  position: relative;
  overflow: hidden;
}

.business-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(var(--primary-color) 1px, transparent 1px);
  background-size: 30px 30px;
  opacity: 0.03;
  pointer-events: none;
}

.business-grid {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 20px;
  position: relative;
  z-index: 2;
}

.business-card {
  width: calc(25% - 15px);
  background-color: var(--light-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.business-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: 2;
}

.business-card:nth-child(1)::before {
  background: linear-gradient(to right, var(--primary-color), #7e57c2);
}

.business-card:nth-child(2)::before {
  background: linear-gradient(to right, var(--secondary-color), #4cd964);
}

.business-card:nth-child(3)::before {
  background: linear-gradient(to right, var(--accent-color), #ffcc00);
}

.business-card:nth-child(4)::before {
  background: linear-gradient(to right, var(--dark-accent), #ff9500);
}

.business-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.card-header {
  margin-bottom: 20px;
}

.card-icon {
  font-size: 2rem;
  margin-bottom: 15px;
}

.business-card h3 {
  margin-bottom: 15px;
  font-size: 1.3rem;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}

.business-card h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  transition: all 0.3s ease;
}

.business-card:hover h3::after {
  width: 50px;
}

.business-card:nth-child(1) h3 {
  color: var(--primary-color);
}

.business-card:nth-child(2) h3 {
  color: var(--secondary-color);
}

.business-card:nth-child(3) h3 {
  color: var(--accent-color);
}

.business-card:nth-child(4) h3 {
  color: var(--dark-accent);
}

.service-list {
  display: grid;
  gap: 15px;
}

.service-item h4 {
  color: var(--text-primary);
  font-size: 1.1rem;
  margin-bottom: 5px;
}

.service-item p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
}

/* 核心优势样式 */
.advantage-section {
  padding: 80px 0;
  background:
    radial-gradient(circle at center, rgba(255, 99, 71, 0.08) 0%, transparent 70%),
    linear-gradient(135deg, rgba(255, 140, 0, 0.06) 0%, transparent 60%);
  position: relative;
}

.advantage-grid {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 40px;
}

.advantage-card {
  flex: 1;
  background: var(--card-bg);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-align: center;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.advantage-icon {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.advantage-card h3 {
  color: var(--primary-color);
  font-size: 1.3rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.advantage-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.advantage-list li {
  color: var(--text-secondary);
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
  line-height: 1.5;
}

.advantage-list li::before {
  content: '•';
  color: var(--primary-color);
  position: absolute;
  left: 0;
  font-size: 1.2em;
}

/* 企业荣誉样式 */
.honor-section {
  padding: 80px 0;
  background-color: var(--card-bg);
  position: relative;
}

.honor-grid {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 40px;
}

.honor-card {
  flex: 1;
  text-align: center;
  padding: 30px;
  background: var(--light-bg);
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.honor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.honor-icon {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.honor-card h3 {
  color: var(--primary-color);
  font-size: 1.3rem;
  margin-bottom: 15px;
  font-weight: 600;
}

.honor-card p {
  color: var(--text-secondary);
  line-height: 1.5;
}

/* 页脚样式 */
.footer {
  background: linear-gradient(to right, #333333, #444444);
  color: white;
  padding: 50px 0 30px;
  position: relative;
}

.footer-grid {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 30px;
}

.footer-info h3 {
  font-size: 1.3rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.footer-info p {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.footer-contact h4 {
  font-size: 1.1rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
}

/* 响应式样式 */
@media (max-width: 1024px) {
  .business-card {
    width: calc(50% - 15px);
  }

  .advantage-grid,
  .honor-grid {
    flex-direction: column;
  }

  .advantage-card,
  .honor-card {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .nav-content {
    flex-direction: column;
    padding: 10px;
  }

  .nav-links {
    margin-top: 15px;
  }

  .banner-content h2 {
    font-size: 2rem;
  }

  .market-stats {
    flex-direction: column;
    align-items: center;
  }

  .stat-item {
    width: 100%;
    max-width: 300px;
    margin-bottom: 30px;
  }

  .footer-grid {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .business-card {
    width: 100%;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .banner {
    padding: 60px 20px;
  }

  .stat-circle {
    width: 140px;
    height: 140px;
  }
}

/* 动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.scroll-animation {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease-out;
}

.scroll-animation.animate {
  opacity: 1;
  transform: translateY(0);
}
</style>